import {
  ChangeDetectionStrategy,
  Component,
  Injector,
  ViewEncapsulation,
} from '@angular/core';

import { ICellRendererParams } from 'ag-grid-community';
import { AgRendererComponent } from 'ag-grid-angular';
import { get } from 'lodash';
import { TooltipIconConfig } from '@app/shared/types';

@Component({
  selector: 'xvi-custom-text-renderer',
  templateUrl: './custom-text-renderer.component.html',
  styleUrls: ['./custom-text-renderer.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CustomTextRendererComponent implements AgRendererComponent {
  public iconConfig: TooltipIconConfig;
  public value: string = '';

  public constructor(public injector: Injector) {}

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  public refresh(params: any): boolean {
    return true;
  }

  public agInit(params: ICellRendererParams): void {
    const placeholder = get(params, 'placeholder', '');
    this.value = get(params, 'valueFormatted', placeholder);
    this.iconConfig = get(params, 'iconConfig', null);
  }
}
